type Condition = {
  term?: { [key: string]: string };
  terms?: { [key: string]: string[] };
};

type FilterObj = {
  must?: Condition[];
  must_not?: Condition[];
  should?: Condition[];
};

export function createPredicate(filterString: string): (obj: { [key: string]: any }) => boolean {
  try {
    const filterObj: FilterObj = JSON.parse(filterString);

    return function (obj: { [key: string]: any }): boolean {
      if (filterObj?.must && !filterObj.must.every((condition) => evaluateCondition(condition, obj))) {
        return false;
      }
      if (filterObj?.must_not && filterObj.must_not.some((condition) => evaluateCondition(condition, obj))) {
        return false;
      }
      if (filterObj?.should && !filterObj.should.some((condition) => evaluateCondition(condition, obj))) {
        return false;
      }
      return true;
    };
  } catch (error) {
    console.error('Error parsing filter string:', error);
    return () => false;
  }
}

function evaluateCondition(condition: Condition, obj: { [key: string]: any }): boolean {
  if (condition.term) {
    for (const key in condition.term) {
      if (obj[key] !== condition.term[key]) return false;
    }
  }

  if (condition.terms) {
    for (const key in condition.terms) {
      if (!condition.terms[key].includes(obj[key])) return false;
    }
  }

  return true;
}
